import React from 'react';

function DesignPage() {
  return (
    <div style={{ padding: '2rem' }}>
      <h1>Design Brief</h1>
      <p>This is the design brief page. Add your content here.</p>
    </div>
  );
}

export default DesignPage;
